import { createFromIconfontCN } from '@ant-design/icons';
import { get, find, orderBy, map, uniqBy, trim, lowerCase, flow, sortBy, filter } from 'lodash';
import moment from 'moment';
/* eslint no-useless-escape:0 */
const reg = /(((^https?:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.-]+(?::\d+)?|(?:www.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w-_]*)?\??(?:[-\+=&;%@.\w_]*)#?(?:[\w]*))?)$/;
import { Tooltip } from 'antd';

export function isUrl(path) {
  return reg.test(path);
}

export function upperCaseFirstLetter(string) {
  if (typeof string !== 'string') return string;
  return string.replace(/(?:^|\s)\S/g, a => a.toUpperCase());
}

// Allow menu.js config icon as string or ReactNode
//   icon: 'setting',
//   icon: 'http://demo.com/icon.png',
//   icon: <Icon type="setting" />,
export function getIcon(icon) {
  if (typeof icon === 'string' && isUrl(icon)) {
    return <img src={icon} alt="icon" className={styles.icon} />;
  }
  // if (typeof icon === 'string') {
  //   // return <IconFont type={icon} style={{ fontSize: '20px' }} />;
  // }
  return icon;
}

export function convertToHalfwidth(s) {
  if (!s) {
    return s;
  }
  let data = s.replace(/[\uff01-\uff5e]/g, function(ch) {
    return String.fromCharCode(ch.charCodeAt(0) - 0xfee0);
  });

  return data.normalize('NFKD');
}

export const daysOfWeek = [
  'Sunday',
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
];
export const imageFallback =
  'data:image/png;base64,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';
export function getImage(media, size) {
  let url;
  if (typeof media === 'string') {
    url = media;
  } else {
    if (size) {
      url = get(media, `formats.${size}.url`, get(media, 'url'));
    } else {
      url = get(media, 'url');
    }
  }
  if (url) {
    return `${url.indexOf('http') === 0 ? '' : BASE_URL}${url}`;
  }
  return imageFallback;
}

export function formatRichText(value = '') {
  return {
    dangerouslySetInnerHTML: {
      __html: formatRichTextOnly(value),
    },
  };
}

export function formatRichTextOnly(value = '') {
  return (value || '').replace(/(?:\r\n|\r|\n)/g, '<br/>');
}

export const IconFont = createFromIconfontCN({
  scriptUrl: '//at.alicdn.com/t/font_1243735_j979k6l01v8.js',
});
/*
export function checkEmail (email) {

  if (!email) {
    return
  }
  const filterEmails = []

  email = email.trim()

  if (validateEmail(email)) {
    // return email if it's valid
    filterEmails.push(email)
    return filterEmails
  }

  const splitEmails = email.split(/,|;|\s+|\//)

  for (let splitEmail of splitEmails) {
    splitEmail = splitEmail.trim()
    if (validateEmail(splitEmail)) {
      filterEmails.push(splitEmail);
      continue;
    }

    const matched = splitEmail.match(/.+<(.+)>/)
    if (!matched)  {
      continue;
    }

    if (validateEmail(matched[1])) {
      filterEmails.push(matched[1]);
    }
    // tried our best, no valid email
  }
  return filterEmails
}
*/

export function validateEmail(email) {
  return String(email)
    .toLowerCase()
    .match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    );
}

export function convertToYYYMMDD(data) {
  const dateFields = [
    'release_date',
    'eta',
    'transit_eta',
    'etd',
    'transit_etd',
    'final_eta',
    'place_of_delivery_eta',
    'place_of_receipt_etd',
    'telex_release_received_date',
    'entry_date',
    'it_date',
    'arrival_notice_sent_date',
    'available_date',
    'delivery_order_sent_date',
    'door_delivery_date',
    'last_free_date',
    'original_bl_received_date',
    'original_bl_released_date',
    'customs_release_date',
    'on_board_date',
    'earliest_return_date',
    'post_at',
    'go_date',
    'booking_requested_date',
    'booking_confirmed_date',
    'ci_pl_received_date',
    'isf_filed_date',
    'hbl_issued_date',
    'ams_accepted_date',
    'ata',
    'delivery_pickup_date',
    'equipment_return_date',
    'atd',
    'etb',
  ];

  for (const k of Object.keys(data)) {
    if (dateFields.includes(k) && data[k]) {
      data[k] = moment(data[k]).format('YYYY-MM-DD');
    }
  }
  return data;
}

export function getExcelDateNumberFormat(dateFormat = 'MM/DD/YY', options = {}) {
  const { withTime = false } = options;
  const normalizedFormat =
    String(dateFormat || 'MM/DD/YY')
      .trim()
      .replace(/yyyy/g, 'YYYY')
      .replace(/yy/g, 'YY')
      .replace(/dd/g, 'DD') || 'MM/DD/YY';

  let excelFormat = normalizedFormat
    .replace(/YYYY/g, 'yyyy')
    .replace(/YY/g, 'yy')
    .replace(/MMMM/g, 'mmmm')
    .replace(/MMM/g, 'mmm')
    .replace(/MM/g, 'mm')
    .replace(/\bM\b/g, 'm')
    .replace(/DD/g, 'dd')
    .replace(/\bD\b/g, 'd')
    .replace(/HH/g, 'hh')
    .replace(/\bH\b/g, 'h');

  if (/[aA]/.test(normalizedFormat)) {
    excelFormat = excelFormat.replace(/[aA]/g, 'AM/PM');
  }

  if (withTime && !/[hH]/.test(normalizedFormat)) {
    excelFormat = `${excelFormat} hh:mm`;
  }

  return excelFormat || 'mm/dd/yy';
}

// Moved to ./excelExport (pure, unit-testable); re-exported for existing call sites.
export { getExcelDateCellValue } from './excelExport';

export function formatDateOrDateTime(
  dateValue,
  dateHourOrDateTimeValue,
  dateTimeOrDateFormat = 'YYYY-MM-DD',
  maybeDateFormat,
) {
  const hasSeparateHour = typeof maybeDateFormat === 'string';
  const dateHourValue = hasSeparateHour ? dateHourOrDateTimeValue : undefined;
  const dateTimeValue = hasSeparateHour ? dateTimeOrDateFormat : dateHourOrDateTimeValue;
  const dateFormat = hasSeparateHour ? maybeDateFormat : dateTimeOrDateFormat;

  if (dateValue) {
    const date = moment(dateValue);
    if (!date.isValid()) return '';
    if (dateHourValue) {
      return `${date.format(dateFormat)} ${dateHourValue}`;
    }
    return date.format(dateFormat);
  }

  if (dateTimeValue) {
    const dateTime = moment(dateTimeValue);
    return dateTime.isValid() ? dateTime.format(`${dateFormat} HH:mm`) : '';
  }

  return '';
}

export function getShopSetting(user, key, field, office) {
  const setting = find(user?.shop?.settings || [], setting => {
    return setting.name === key;
  });
  if (office) {
    const officeSetting = find(user?.shop?.settings || [], setting => {
      return setting.office?.toString() === office.toString() && setting.name === key;
    });
    if (officeSetting) {
      return get(officeSetting, `${field}`);
    }
  }
  return get(setting, `${field}`);
}

const SpaceHolder = <div className="w-20 min-w-full text-center">-</div>;
export function eclipse(s, { maxLength } = {}) {
  maxLength = maxLength || 25;
  return s ? (
    s.length < maxLength ? (
      s
    ) : (
      <Tooltip title={s}> {s.substring(0, maxLength - 1) + '...'}</Tooltip>
    )
  ) : (
    SpaceHolder
  );
}

export { getMemberName } from './member';

export function getCurrencies(user) {
  const orderByCustomize = {
    RMB: 1,
    USD: 2,
  };
  const options = map(
    orderBy(
      uniqBy(
        map(user?.shop?.currencies, currency => ({
          value: `${currency.name}`,
          order: orderByCustomize[currency.name] || 99,
        })),
        'value',
      ),
      ['order'],
      ['asc'],
    ),
    currency => currency.value,
  );
  return options;
}

// 先支持一个string
export function isIncludes(collection, value, options = { formats: [lowerCase, trim] }) {
  if (!collection || !value || typeof collection !== 'string' || typeof value !== 'string') {
    return false;
  }
  const formats = flow(options.formats);
  const collectionLowerCase = formats?.(collection);
  const valueLowerCase = formats?.(value);
  if (!collectionLowerCase || !valueLowerCase) {
    return false;
  }
  return collectionLowerCase.includes(valueLowerCase);
}

// loadExcelColumns 抽到纯文件 ./excelColumns;此处 re-export 保持所有现有调用方路径不变。
export { loadExcelColumns } from './excelColumns';

/**
 * Enhanced version of loadExcelColumns that supports nested columns (children) and proper ordering
 *
 * This function filters and sorts columns based on user's visibility and ordering preferences
 * stored in localStorage. It properly handles:
 * - Nested columns (parent columns with children)
 * - Parent column visibility (hides all children if parent is hidden)
 * - Individual child column visibility
 * - Column ordering based on user settings
 * - Optional whitelist filtering for security
 *
 * @param {Array} columns - Array of column definitions
 * @param {string} localstorageKey - localStorage key name for column state
 * @param {Object} options - Optional configuration
 * @param {Array} options.includeOnly - Whitelist of column keys to include (for security filtering)
 * @param {boolean} options.keepNestedStructure - If true, keeps parent-child structure instead of flattening (default: false)
 * @returns {Array} Filtered and sorted array of columns
 *
 * @example
 * // Basic usage (flattened)
 * const visibleColumns = loadExcelColumnsWithOrder(columns, 'my_table_state');
 *
 * @example
 * // Keep nested structure for further processing
 * const nestedColumns = loadExcelColumnsWithOrder(columns, 'my_table_state', {
 *   keepNestedStructure: true
 * });
 *
 * @example
 * // With whitelist
 * const safeColumns = loadExcelColumnsWithOrder(columns, 'my_table_state', {
 *   includeOnly: ['col1', 'col2', 'col3']
 * });
 */
export function loadExcelColumnsWithOrder(columns, localstorageKey, options = {}) {
  const { includeOnly, keepNestedStructure = false } = options;

  let setting = null;
  try {
    setting = JSON.parse(localStorage.getItem(localstorageKey));
  } catch (error) {}

  // Process columns based on whether to keep nested structure or flatten
  const processedColumns = [];

  columns.forEach((col, index) => {
    if (col.children) {
      // Check if parent column should be shown
      const parentShow = col.key ? setting?.[col.key]?.show !== false : true;
      if (!parentShow) {
        return; // Parent is hidden, skip entire column group
      }

      // Filter child columns based on their individual visibility
      const visibleChildren = col.children.filter(child => {
        const childShow = child.key ? setting?.[child.key]?.show !== false : true;
        return childShow && !child.hideInTable;
      });

      if (keepNestedStructure) {
        // Keep the parent-child structure
        if (visibleChildren.length > 0) {
          processedColumns.push({
            ...col,
            children: visibleChildren,
            _order: setting?.[col.key]?.order ?? Number.MAX_SAFE_INTEGER,
          });
        }
      } else {
        // Flatten: add children directly to the array
        visibleChildren.forEach(child => {
          processedColumns.push({
            ...child,
            // Store parent's order for sorting child columns together
            _parentOrder: setting?.[col.key]?.order ?? Number.MAX_SAFE_INTEGER,
          });
        });
      }
    } else {
      // Regular column (no children)
      const shouldShow = col.key ? setting?.[col.key]?.show !== false : true;
      if (shouldShow && !col.hideInTable) {
        processedColumns.push({
          ...col,
          _order: setting?.[col.key]?.order ?? Number.MAX_SAFE_INTEGER,
        });
      }
    }
  });

  // Apply whitelist filtering if provided (for security)
  let filteredColumns = processedColumns;
  if (includeOnly && Array.isArray(includeOnly)) {
    filteredColumns = processedColumns.filter(col => {
      if (!col.key && !col.dataIndex) return false;
      const key = col.key || col.dataIndex;
      return includeOnly.includes(key);
    });
  }

  // ProTable renders fixed-left columns first and fixed-right columns last.
  // Keep Excel in the same visual order before applying drag-and-drop order.
  const getFixedOrder = column => {
    const hasStoredSetting =
      column.key && Object.prototype.hasOwnProperty.call(setting || {}, column.key);
    const fixed = hasStoredSetting ? setting[column.key]?.fixed : column.fixed;
    if (fixed === 'left') return -1;
    if (fixed === 'right') return 1;
    return 0;
  };

  // Sort columns based on user's ordering preference
  const sortedColumns = filteredColumns.sort((a, b) => {
    const fixedOrderDifference = getFixedOrder(a) - getFixedOrder(b);
    if (fixedOrderDifference !== 0) {
      return fixedOrderDifference;
    }

    // Use column's own order, or parent's order for child columns, or _order property, or MAX for no order
    const orderA = setting?.[a.key]?.order ?? a._parentOrder ?? a._order ?? Number.MAX_SAFE_INTEGER;
    const orderB = setting?.[b.key]?.order ?? b._parentOrder ?? b._order ?? Number.MAX_SAFE_INTEGER;
    return orderA - orderB;
  });

  return sortedColumns;
}

export const getStyleFromString = style => {
  if (!style) return undefined;
  return Object.entries(style)
    .map(([k, v]) => `${k}:${v}`)
    .join(';');
};

export const DEFAULT_VOL = 1;

export const getDocUrl = doc => {
  if (!doc) return '';
  let url;
  if (typeof doc === 'string') {
    url = doc;
  } else {
    url = get(doc, 'files[0].url') || get(doc, 'url') || '';
  }
  if (!url) return '';
  const host = window?.location?.host;
  if (!host || host.indexOf('localhost') > -1) return url;
  const subdomain = host.split('.')[0];
  if (url.indexOf('smartforwarder-hz-prod.oss-cn-hangzhou.aliyuncs.com') > -1) {
    url = subdomain
      ? url.replace(
          'smartforwarder-hz-prod.oss-cn-hangzhou.aliyuncs.com',
          `${subdomain}.dongyun.cloud`,
        )
      : url;
  } else if (url.indexOf('smartforwarder-hk-prod.oss-cn-hongkong.aliyuncs.com') > -1) {
    url = url.replace('smartforwarder-hk-prod.oss-cn-hongkong.aliyuncs.com', host);
  } else if (url.indexOf('smartforwarder-prod.oss-us-east-1.aliyuncs.com') > -1) {
    url = url.replace('smartforwarder-prod.oss-us-east-1.aliyuncs.com', host);
  }
  return url;
};

export const getPortType = shipmentType => {
  if (shipmentType && shipmentType.startsWith('air')) {
    return 'airport';
  } else if (shipmentType && shipmentType.startsWith('ocean')) {
    return 'sea_port';
  }
  return undefined;
};
